import React, { useEffect, useState } from 'react';
import { Modal } from 'antd';
import { httpGet, httpPost, httpUrl } from '../../api/httpClient';
import { comma } from '../../lib/util/numberUtil';
import moment from 'moment';
import { DatePicker, Button } from 'antd';
import * as XLSX from 'xlsx';
import Pagination from '../input/Pagination';
import 'moment/locale/ko';
import locale from 'antd/es/date-picker/locale/ko_KR';
import {categoryCode, modalErrorStyle} from '../../lib/util/codeUtil';
import { reactLocalStorage } from 'reactjs-localstorage';
import Const from '../../const';
import string from '../../res/string';
import image from '../../res/image';

const { RangePicker } = DatePicker;
const dateFormat = 'YYYY-MM-DD';
const dateTimeFormat = 'YYYY-MM-DD HH:00:00';
const now = new Date();
const now2 = new Date();
const PagedListSize = 5;

const header = [
  {
    historyDate: '일시',
    ncashSend: '라이더 전송',
    cashOrderPriceReceive: '현금배달입금',
    ncashSendByAdmin: string.ncashSendByAdmin,
    duesPay: '가맹비',
    ncashChargeProc: '충전',
    withdrawReq: '출금',
    batchWorkNcash: '일차감',
    // moneySum: "매출금액"
    deliveryPriceSend: '배달비',
    deliveryPriceSendRestore: '배달비 취소',
  },
];

const defKindType = {
  daily: 1,
  monthly: 2,
};

const UseList = () => {
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 9,
    startDate: moment(now).add(-6, 'M'),
    endDate: now,
    //startDate: moment(now.setHours(reactLocalStorage.getObject(Const.appName + "#calculateHour"))).add(-6, "M"),
    //endDate: moment(now.setHours(reactLocalStorage.getObject(Const.appName + "#calculateHour"))),
  });
  const [list, setList] = useState([]);
  var object = {
    historyDate: moment(now).format(dateFormat),
    ncashSend: 0,
    cashOrderPriceReceive: 0,
    ncashSendByAdmin: 0,
    duesPay: 0,
    ncashChargeProc: 0,
    withdrawReq: 0,
    deliveryPriceSend: 0,
    deliveryPriceSendRestore: 0,
  };
  const [total, setTotal] = useState(0);
  const [selectOpen, setSelectOpen] = useState(false);
  const [selectCategory, setSelectCategory] = useState(
    Object.keys(categoryCode)
  );

  const [kind, setKind] = useState(defKindType.daily);

  //   useEffect(() => {
  //     const getListAsync = async () => {
  //       const pageNum = pagination.current;
  //       const pageSize = pagination.pageSize;
  //       const startDate = moment(pagination.startDate).format(dateFormat);
  //       const endDate = moment(pagination.endDate).format(dateFormat);

  //       try {
  //         const res = await httpGet(
  //           httpUrl.useList,
  //           [
  //             endDate,
  //             pageNum,
  //             pageSize,
  //             startDate,
  //         ],
  //           {
  //             // categories: selectCategory,
  //           }
  //         );
  //         if (res.result !== "SUCCESS") {
  //           setList([]);
  //           setTotal(0);
  //           // console.log(`getListAsync failed. result: ${res.result}`);
  //           return;
  //         }

  //         setList(res.data.ncashDailyList);
  //         setTotal(res.data.totalCount);
  //       } catch (e) {
  //         setList([]);
  //         setTotal(0);
  //         console.warn("getListAsync failed. " + e);
  //       }
  //     };

  //     getListAsync();
  //   }, [pagination]);

  // const onChange = (page) => {
  //   setPagination({
  //     ...pagination,
  //     current: page,
  //   });

  //   const [list, setList] = useState([]);
  //   const [total, setTotal] = useState(0);

  //   const [kind, setKind] = useState(defKindType.daily);

  useEffect(() => {
    getListAsync();
  }, [pagination]);

  const getListAsync = async () => {
    const pageNum = pagination.current;
    const pageSize = 100000000;
    const startDateTime = moment(pagination.startDate)
      .format(dateTimeFormat);
    let endDateTime = moment(pagination.endDate)
      .format(dateTimeFormat);

    setList([]);

    if (kind == 1) {
      // console.log(`end data: ${endDateTime}`);
      const res = await httpGet(
          httpUrl.useList,
          [endDateTime, 1, 500, startDateTime],
          {}
      );

      if (res.result !== 'SUCCESS') {
        // console.log(`getListAsync failed. result: ${res.result}`);
        setTotal(0);
        return;
      }

      setList(
          res.data.histories2.slice(
              (pagination.current - 1) * pagination.pageSize,
              (pagination.current - 1) * pagination.pageSize + pagination.pageSize
          )
      );
      setTotal(res.data.totalCount);
    } else {
      const res = await httpGet(
        httpUrl.useMonthList,
        [endDateTime, pageNum, pageSize, startDateTime],
        {}
      );
      if (res.result !== 'SUCCESS') {
        // console.log(`getListAsync failed. result: ${res.result}`);
        return;
      }

      setList(res.data.histories2);
      setTotal(res.data.totalCount);
    }
  };

  const onCheckList = (id) => {
    var selectedList = selectCategory;
    if (selectCategory.includes(id)) {
      setSelectCategory(selectedList.filter((x) => x !== id));
    } else {
      setSelectCategory([...selectedList, id]);
    }
  };

  const onChange = (page) => {
    setPagination({
      ...pagination,
      current: page,
    });
  };

  const onChangeDatePickerStart = (_, dateString) => {
    if (dateString) {
      if (new Date(pagination.endDate) - new Date(dateString) > 0) {
        setPagination({
          ...pagination,
          current: 1,
          startDate: dateString,
        });
      } else {
        setPagination({
          ...pagination,
          current: 1,
          startDate: pagination.endDate,
          endDate: dateString,
        });
      }
    } else {
      setPagination({
        ...pagination,
        current: 1,
        startDate: moment(now).add(-3, 'M'),
        endDate: now,
      });
    }
  };

  const onChangeDatePickerEnd = (_, dateString) => {
    if (dateString) {
      if (new Date(pagination.startDate) - new Date(dateString) < 0) {
        setPagination({
          ...pagination,
          current: 1,
          endDate: dateString,
        });
      } else {
        setPagination({
          ...pagination,
          current: 1,
          startDate: dateString,
          endDate: pagination.startDate,
        });
      }
    } else {
      setPagination({
        ...pagination,
        current: 1,
        startDate: moment(now).add(-3, 'M'),
        endDate: now,
      });
    }
  };

  const onChangeRangePicker = (_, dateString) => {
    // const startDate = dateString[0];
    // const endDate = dateString[1];
    if (dateString[0]) {
      setPagination({
        ...pagination,
        current: 1,
        startDate: dateString[0],
        endDate: dateString[1],
      });
    } else {
      setPagination({
        ...pagination,
        current: 1,
        startDate: moment(now).add(-6, 'M'),
        endDate: now,
      });
    }
  };

  const onChangeKindType = (kindType) => {
    setKind(kindType);
    setPagination({
      ...pagination,
      current: 1,
    });
  };

  const onDownload = async () => {
    //const startDate = moment(pagination.startDate).format(dateFormat);
    //const endDate = moment(pagination.endDate).format(dateFormat);
    const pageSize = 100000000;
    const startDateTime = moment(pagination.startDate)
      .format(dateTimeFormat);
    let endDateTime = moment(pagination.endDate)
      .format(dateTimeFormat);

    if (kind == 1) {
      const res = await httpGet(
          httpUrl.useList,
          [endDateTime, 1, 100000000, startDateTime],
          {}
      );


      if (res.result !== 'SUCCESS') {
        Modal.error({
          title: '엑셀 다운로드 오류',
          content: (
              <div>
                엑셀로 저장하는 동안 오류가 발생했습니다. 다시 시도해 주십시오.
              </div>
          ),
          ...modalErrorStyle,
        });
        return;
      }

      const title = '통계';
      const filename =
          moment().format('YYYYMMDDhhmmss') + '_' + title + '.xlsx';
      const sheetName = ' 일별';

      const jsonData = res.data.histories2.map((row) => ({
        historyDate: moment(row.historyDate).format('YYYY-MM-DD'),
        ncashSend: row.ncashSend,
        cashOrderPriceReceive: row.cashOrderPriceReceive,
        ncashSendByAdmin: row.ncashSendByAdmin,
        duesPay: row.duesPay,
        ncashChargeProc: row.ncashChargeProc,
        withdrawReq: row.withdrawReq,
        batchWorkNcash: row.batchWorkNcash,
        deliveryPriceSend: row.deliveryPriceSend,
        deliveryPriceReceive: row.deliveryPriceReceive,
        // moneySum: row.moneySum,
      }));

      const array = header.concat(jsonData);

      var ws = XLSX.utils.json_to_sheet(array, { skipHeader: true });
      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, sheetName);
      XLSX.writeFile(wb, filename);
    } else {
      const res = await httpGet(
        httpUrl.useMonthList,
        [endDateTime, 1, 100000000, startDateTime],
        {}
      );
      if (res.result !== 'SUCCESS') {
        Modal.error({
          title: '엑셀 다운로드 오류',
          content: (
            <div>
              엑셀로 저장하는 동안 오류가 발생했습니다. 다시 시도해 주십시오.
            </div>
          ),
          ...modalErrorStyle,
        });
        return;
      }

      const title = '통계';
      const filename =
        moment().format('YYYYMMDDhhmmss') + '_' + title + '.xlsx';
      const sheetName = ' 월별';

      const jsonData = res.data.histories2.map((row) => ({
        historyDate: moment(row.historyDate).format('YYYY-MM'),
        ncashSend: row.ncashSend,
        cashOrderPriceReceive: row.cashOrderPriceReceive,
        ncashSendByAdmin: row.ncashSendByAdmin,
        duesPay: row.duesPay,
        ncashChargeProc: row.ncashChargeProc,
        withdrawReq: row.withdrawReq,
        batchWorkNcash: row.batchWorkNcash,
        deliveryPriceSend: row.deliveryPriceSend,
        deliveryPriceReceive: row.deliveryPriceReceive,
        // moneySum: row.moneySum,
      }));

      const array = header.concat(jsonData);

      var ws = XLSX.utils.json_to_sheet(array, { skipHeader: true });
      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, sheetName);
      XLSX.writeFile(wb, filename);
    }
  };

  const skinType = Const.skinType.toUpperCase();

  return (
    <>
      <div className="calculate-adjustment-element">
        <div className="calculate-adjustment-element-menu">
          <div className="calculate-adjustment-element-menu-all">
            <div className="calculate-adjustment-element-menu-all">
              {/* <div className="calculate-element-menu-check useList-check">
                <div
                  className="calculate-element-menu-check-sub"
                  onClick={() => {
                    setSelectOpen(!selectOpen);
                  }}
                >
                  <div
                    className={
                      selectOpen
                        ? "calculate-element-menu-check-all-color"
                        : "calculate-element-menu-check-all"
                    }
                  >
                    분류선택
                    <img
                      src={
                        selectOpen
                          ? require("../../img/body/select.png").default
                          : require("../../img/body/unselect.png").default
                      }
                      alt=""
                      className="select-img2"
                    />
                  </div>
                </div>
                {selectOpen && (
                  <div className="calculate-element-menu-check-menu">
                    {Object.keys(categoryCode).map((key) => (
                      <div key={key}>
                        <div className="all-category-box">
                          <div
                            className={
                              selectCategory.includes(key)
                                ? "calculate-element-menu-check-element"
                                : "calculate-element-menu-check-element2"
                            }
                            onClick={() => onCheckList(key)}
                          >
                            <div className="all-category">
                              {categoryCode[key]}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div> */}

              <div
                className="calculate-adjustment-element-menu-btn mobileoff"
                onClick={() => {}}>
                <Button className="excel" onClick={() => onDownload()}>
                  엑셀 다운로드 &nbsp;
                  <img
                    style={{ display: 'inline' }}
                    src={image.DownloadIcon}
                    className="download-img"
                    alt=""
                  />
                </Button>
              </div>
            </div>
          </div>
          <div className="calculate-adjustment-element-menu-all cal-adj2">
            <div className="delivery-element-menu-text2 text2-sub2">
              기간조회
            </div>
            <div className="calculate-adjustment-content-date">
              <DatePicker
                className="desk"
                placeholder={'시작일'}
                locale={locale}
                style={{
                  height: '50px',
                  borderRadius: '10px',
                  marginTop: '-5px',
                }}
                size="large"
                format={dateFormat}
                value={moment(pagination.startDate, dateFormat)}
                onChange={onChangeDatePickerStart}
                inputReadOnly
                showToday={false}
              />
              <DatePicker
                className="desk"
                placeholder={'종료일'}
                locale={locale}
                style={{
                  height: '50px',
                  borderRadius: '10px',
                  marginTop: '-5px',
                }}
                size="large"
                format={dateFormat}
                value={moment(pagination.endDate, dateFormat)}
                onChange={onChangeDatePickerEnd}
                inputReadOnly
                showToday={false}
              />
              {/* <RangePicker
                className="desk"
                locale={locale}
                style={{
                  marginLeft: "10px",
                  height: "50px",
                  borderRadius: "10px",
                  marginTop: "-5px",
                }}
                size="large"
                format={dateFormat}
                value={[
                  moment(pagination.startDate, dateFormat),
                  moment(pagination.endDate, dateFormat),
                ]}
                onChange={onChangeRangePicker}
              /> */}
              <DatePicker
                className="pos"
                placeholder={'시작일'}
                locale={locale}
                style={{
                  height: '40px',
                  borderRadius: '10px',
                  marginTop: '-5px',
                }}
                size="middle"
                format={dateFormat}
                value={moment(pagination.startDate, dateFormat)}
                onChange={onChangeDatePickerStart}
                inputReadOnly
                showToday={false}
              />
              <DatePicker
                className="pos"
                placeholder={'종료일'}
                locale={locale}
                style={{
                  height: '40px',
                  borderRadius: '10px',
                  marginTop: '-5px',
                }}
                size="middle"
                format={dateFormat}
                value={moment(pagination.endDate, dateFormat)}
                onChange={onChangeDatePickerEnd}
                inputReadOnly
                showToday={false}
              />
              {/* <RangePicker
                className="pos"
                locale={locale}
                style={{
                  marginLeft: "10px",
                  height: "40px",
                  borderRadius: "10px",
                  marginTop: "-5px",
                }}
                size="middle"
                format={dateFormat}
                value={[
                  moment(pagination.startDate, dateFormat),
                  moment(pagination.endDate, dateFormat),
                ]}
                onChange={onChangeRangePicker}
              /> */}
            </div>

            <div
              className={kind === defKindType.daily && skinType === "GOGOIT" ?
                  'gogoit-delivery-element-menu-text3 active':
                  skinType === "GOGOIT" ? 'gogoit-delivery-element-menu-text3' :
                kind === defKindType.daily
                  ? 'delivery-element-menu-text3 active'
                  : 'delivery-element-menu-text3'
              }
              onClick={() => onChangeKindType(defKindType.daily)}>
              일별통계
            </div>
            <div className="calculate-adjustment-element-menu-line" />
            <div
              className={kind === defKindType.monthly && skinType === "GOGOIT" ?
                  'gogoit-delivery-element-menu-text3 active':
                  skinType === "GOGOIT" ? 'gogoit-delivery-element-menu-text3' :
                      kind === defKindType.monthly
                          ? 'delivery-element-menu-text3 active'
                          : 'delivery-element-menu-text3'
              }
              onClick={() => onChangeKindType(defKindType.monthly)}>
              월별통계
            </div>
          </div>
        </div>

        <div className="calculate-element-sub">
          <div className="useList-element-all">
            <div className="useList-element-block">
              <div className="useList-element-block-menu">
                <div className="useList-element-block-menu-text use1">일시</div>
                <div className="useList-element-block-menu-text use2">
                  라이더전송
                </div>
                <div className="useList-element-block-menu-text use3">
                  현금배달입금
                </div>
                <div className="useList-element-block-menu-text use4">
                  {string.ncashSendByAdmin}
                </div>
                {/* <div className="useList-element-block-menu-text use4">배달비</div> */}
                <div className="useList-element-block-menu-text use5">
                  가맹비
                </div>
                <div className="useList-element-block-menu-text use5">
                  가맹비반환
                </div>
                <div className="useList-element-block-menu-text use6">충전</div>
                <div className="useList-element-block-menu-text use7">출금</div>
                <div className="useList-element-block-menu-text use8">
                  일차감
                </div>
                <div className="useList-element-block-menu-text use8">
                  배달비
                </div>
                <div className="useList-element-block-menu-text use8">
                  배달비취소
                </div>
                {/* <div className="useList-element-block-menu-text use9">
                  매출금액
                </div> */}
              </div>
            </div>

            {(!list || list.length) === 0 && (
                <div style={{textAlign: 'center', padding: '50px' }}>
                내역이 없습니다.
              </div>
            )}
            {list &&
              list.map((row, index) => (
                <div
                  key={index}
                  className={
                    'useList-element-block-field' +
                    (index % 2 === 0 ? '' : ' odd')
                  }>
                  <div className={"useList-element-block-field-text" + (skinType === "GOGOIT" ? " gogoit-use-sub1" : " use-sub1")}>
                    <div>
                      {kind === defKindType.daily
                        ? moment(row.historyDate).format('YYYY-MM-DD')
                        : moment(row.historyDate).format('YYYY-MM')}
                    </div>
                  </div>
                  <div className="useList-element-block-field-text use-sub2">
                    {comma(row.ncashSend)} 원
                  </div>
                  <div className="useList-element-block-field-text use-sub4">
                    {comma(row.cashOrderPriceReceive)} 원
                  </div>
                  <div className="useList-element-block-field-text use-sub3">
                    {comma(row.ncashSendByAdmin)} 원
                  </div>
                  {/* <div className="useList-element-block-field-text use-sub4">
                    {comma(row.deliveryPrice)}
                  </div> */}
                  <div className="useList-element-block-field-text use-sub5">
                    {comma(row.duesPay)} 원
                  </div>
                  <div className="useList-element-block-field-text use-sub5">
                    {comma(row.duesPayCancel)} 원
                  </div>
                  <div className="useList-element-block-field-text use-sub6">
                    {comma(row.ncashChargeProc)} 원
                  </div>
                  <div className="useList-element-block-field-text use-sub7">
                    {comma(row.withdrawReq)} 원
                  </div>
                  <div className="useList-element-block-field-text use-sub8">
                    {comma(row.batchWorkNcash)} 원
                  </div>
                  <div className="useList-element-block-field-text use-sub8">
                    {comma(row.deliveryPriceSend)} 원
                  </div>
                  <div className="useList-element-block-field-text use-sub8">
                    {comma(row.deliveryPriceSendRestore)} 원
                  </div>
                  {/* <div className="useList-element-block-field-text use-sub9">
                    {comma(row.batchWorkNcash)}
                  </div> */}
                </div>
              ))}
          </div>

          <div className="useList-element-btn mobileoff">
            <Pagination
              current={pagination.current}
              total={total}
              pageSize={pagination.pageSize}
              pagedListSize={PagedListSize}
              onChange={onChange}
            />
          </div>
        </div>
      </div>
    </>
  );
};
export default UseList;
